<template>
  <div
    v-if="instructions.length"
    id="instructionsContainer"
  >
    <div class="card">
      <div class="card-body">
        <h5 class="mt-0 card-title">
          Instructions
        </h5>

        <div
          v-for="(instruction, index) in instructions"
          :key="instruction.id"
          class="alert"
          :class="[ instruction.level == 'warning' ? 'alert-danger' : 'alert-warning' ]"
        >
          <h5>
            {{ index + 1 }} - {{ instruction.title }}

            <span
              v-if="!instruction.show"
              class="float-right"
              style="font-size: 13px;"
              @click="showInstruction(instruction)"
            >Afficher</span>
            <span
              v-else
              class="float-right"
              style="font-size: 13px;"
              @click="hideInstruction(instruction)"
            >Cacher</span>
          </h5>

          <p
            v-if="instruction.show"
            class="instruction"
          >
            {{ instruction.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tls from "@/services/Tls";

const name = "GroupInstructions";

const data = function () {
	return {
		instructions: []
	};
};

const hideInstruction = function (instruction) {
	instruction.show = false;
};

const showInstruction = function (instruction) {
	instruction.show = true;
};

const fetchInstructions = function () {
	const { group: { id: groupId }} = this;

	if (groupId) {      
		Tls.Groups.getInstructions(groupId).then(response => {
			const instructions = response.instructions.filter(instruction => instruction.description);
  
			instructions.forEach(instruction => {
				instruction.show = ["important", "warning"].includes(instruction.level);
			});
            
			this.instructions = instructions.sort((a,  b) => a.sort - b.sort);
		});
	}
};

export default {
	name,
	props: {
		group: {
			type: Object,
			required: true
		}
	},
	data,
	watch: {
		group: function (_) {
			fetchInstructions.bind(this)();
		},
	},
	mounted() {
		fetchInstructions.bind(this)();
	},
	methods: {
		hideInstruction,
		showInstruction
	},
};
</script>
